module.exports = __webpack_public_path__ + "assets/pdf/malbec-syrah.7665238e.pdf";